import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EUserType } from '../enums/EUserType';
import { IUser } from '../interfaces/IUser';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    constructor(private router: Router) {
    }

    gotoDashboard(gUser: IUser) {
        if (!gUser) return;
        switch (gUser.usr_type_str) {
            case EUserType.USER: {
                this.router.navigate(['/product']).then();
                break;
            }
        }
    }
}
